import { render, staticRenderFns } from "./SchoolClassModal.vue?vue&type=template&id=1c14e170&scoped=true&"
import script from "./SchoolClassModal.vue?vue&type=script&lang=js&"
export * from "./SchoolClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14e170",
  null
  
)

export default component.exports